module.exports = __webpack_public_path__ + "img/bg-table.56587307.jpg";